import { Flex, Text } from '@chakra-ui/react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { apiService } from 'services/ApiService';
import { settingsConfig } from './settingsConfig';
import { useMutation, useQueryClient } from 'react-query';
import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';

const Row = ({ page }) => {
  const [key, value] = page;

  const config = settingsConfig[key];

  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: (newValue) =>
      apiService.updateSystemSetting({
        id: key,
        [key]: newValue,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(['system-settings']);
    },
  });

  const isUpdateSystemSetting = usePermissionStatusByKey(
    'PATCH:/admin/system-settings',
  );

  if (!config) {
    return null;
  }

  const Component = config.component;

  return (
    <Card padding="24px">
      <CardBody>
        <Flex direction="column" gap={4} w="full">
          <Text variant="title-lg">{config.label || key}</Text>

          <Component
            value={value}
            options={config.options}
            isDisabled={isLoading || !isUpdateSystemSetting}
            onChange={(val) => mutate(val)}
          />
        </Flex>
      </CardBody>
    </Card>
  );
};

export default Row;
